import { Component } from 'react';
import { isEqual } from 'lodash';
import {
  DL_PAGE_NAME_MODAL_ONBOARDING,
  DL_VIRTUAL_PAGE,
} from '@lib/constants';
import { isUserLoggedIn, getFullUserData } from '@lib/user';
import {
  addEventToDataLayer,
} from '@lib/dataLayerUtils';
import { getSignInUrl, getSigninUrlWithOrigin } from '@lib/utils';
import { getFromLocalStorage, setToLocalStorage } from '@lib/localStorage';
import { addAdobeDataEventListeners } from '@lib/atm';
import OnboardingModal from '../OnboardingModal/OnboardingModal';

class PageContainer extends Component {
  constructor(props) {
    super(props);
    const {
      userSessionData: {
        userData,
        userShopsData,
      },
    } = this.props;

    this.state = {
      userData: userData || {},
      userShopsData: userShopsData || [],
    };

    this.activeFocus = null;
    this.syncUserDataOnPage = this.syncUserDataOnPage.bind(this);
    this.setModalBody = this.setModalBody.bind(this);
    this.makeAndOpenSignInModal = this.makeAndOpenSignInModal.bind(this);
    this.makeAndOpenOnboardingModal = this.makeAndOpenOnboardingModal.bind(this);
    this.isUserLoggedInFn = this.isUserLoggedInFn.bind(this);
    this.setActiveFocus = this.setActiveFocus.bind(this);
    this.setElementFocus = this.setElementFocus.bind(this);

    this.pageStateModifiers = {
      syncUserDataOnPage: this.syncUserDataOnPage,
      setModalBody: this.setModalBody,
      makeAndOpenSignInModal: this.makeAndOpenSignInModal,
      isUserLoggedIn: this.isUserLoggedInFn,
      makeAndOpenOnboardingModal: this.makeAndOpenOnboardingModal,
      setActiveFocus: this.setActiveFocus,
      setElementFocus: this.setElementFocus,
    };
  }

  componentDidMount() {
    window.signIn = this.makeAndOpenSignInModal;

    addAdobeDataEventListeners();
  }

  // TODO: investigate why this is an &&
  shouldComponentUpdate(nextProps, nextState) {
    // Only re-render pages on new userData (favouriting shops/offers)
    const {
      userData: prevUserData,
    } = this.state;
    const shouldUpdate = !isEqual(prevUserData && nextState.userData);
    return shouldUpdate;
  }

  setActiveFocus = (pageContext, id) => {
    this.activeFocus = { pageContext, id };
  };

  setElementFocus = (context, itemId, element) => {
    const { pageContext, id } = (this.activeFocus || {});

    if (context && itemId && context === pageContext && itemId === id) {
      element && element.focus && element.focus();
      if (window) {
        window.addEventListener('click', this.clearActiveFocus);
        window.addEventListener('keydown', this.clearActiveFocus);
      }
    }
  };

  // TODO: move all modal related methods to Page.js (KD - Jul 24,2017)
  setModalBody(body, isMobile = false, styles, showClose = true) {
    if (this.modal) {
      this.modal.updateModalBody(body, isMobile, styles, showClose);
    }
  }

  closeOnboardingModal = () => {
    if (!getFromLocalStorage('onboarding_seen')) {
      setToLocalStorage('onboarding_seen', true);
    }
    this.setModalBody(null, false);
  };

  clearActiveFocus = () => {
    this.activeFocus = null;
    if (window) {
      window.removeEventListener('click', this.clearActiveFocus);
      window.removeEventListener('keydown', this.clearActiveFocus);
    }
  };

  // If user choses to browse and not log in, url is created through slugs and urls params from affiliateUrl
  // If user logs in, user is redirected to redirectUrl
  makeAndOpenSignInModal = async () => {
    const {
      requestData: {
        urlLocale,
      },
    } = this.props;

    try {
      const signinUrl = getSigninUrlWithOrigin({
        currentPath: window.location.href,
        signInUrl: getSignInUrl(urlLocale),
      });

      window.location.href = signinUrl;
    } catch (error) {
      console.error('[Redirect to sign-in]:', error);
    }
  };

  makeAndOpenOnboardingModal(isMobile = false) {
    const {
      requestData: {
        urlLocale,
      },
    } = this.props;

    const modalBody = this.onboardingModal ? (
      <OnboardingModal
        onboardingModalData={this.onboardingModal}
        isMobile={isMobile}
        locale={urlLocale}
        closeModal={this.closeOnboardingModal} />
    ) : null;

    // Add event to dataLayer
    const eventProps = {
      pageName: DL_PAGE_NAME_MODAL_ONBOARDING,
    };
    addEventToDataLayer(DL_VIRTUAL_PAGE, eventProps);

    this.setModalBody(modalBody, isMobile, {
      desktop: {
        content: {
          'borderRadius': '16px',
        },
      },
      mobile: {},
    }, false);
  }

  isUserLoggedInFn() {
    const {
      userSessionData,
    } = this.props;

    return isUserLoggedIn(userSessionData.userData);
  }

  /**
   * Function is called whenever an interaction on the page modifies the user state
   * Examples: Favouriting/Unfavouriting a shop, Saving/Unsaving an offer, on page load if logged in
   *
   * Returns a promise
   ** */
  async syncUserDataOnPage() {
    const {
      userSessionData: {
        userData: userDataProps,
      },
      requestData: {
        urlLocale,
      },
    } = this.props;

    if (!isUserLoggedIn(userDataProps)) {
      return Promise.resolve();
    }

    // // update this.state.userData if logged in
    return getFullUserData(urlLocale).then(({
      userData,
      userShopsData,
    }) => {

      if (!isEqual(userData, this.state.userData)) {
        this.setState({
          userData,
          userShopsData,
        });
      }
    });
  }
}

export default PageContainer;
